import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import SuppliersManager from '@/components/suppliers/SuppliersManager';

export default function AdminSuppliers() {
  return <AppShell nav={adminNav} title="Supplier"><SuppliersManager /></AppShell>;
}
